<template>
    <div class="content-wrapper">
        <!-- Page Loader -->
        <div class="vld-parent">
            <loading :active.sync="isLoading" :is-full-page="fullPage"></loading>
        </div>

        <breadcrumb :page="$t('form.employee.createStaff')"></breadcrumb>

        <div class="content">
            <div class="container-fluid">

                <b-alert v-model="alert" :variant="alertClass" dismissible fade>{{alertMessage}}</b-alert>

                <div class="card">
                    <form>
                        <div class="card-header bg-light">
                            <div class="card-title">{{$t('form.employee.createStaff')}}</div>
                            <button type="button" @click="saveStaff()"
                                class="btn btn-primary float-right">{{$t('button.save')}}</button>
                        </div>

                        <div class="card-body">
                            <b-tabs content-class="mt-3">
                                <b-tab :title="$t('form.employee.tabPersonal')" active>

                                    <div class="row">

                                        <div class="col-md-3 col-sm-4">
                                            <div class="form-group">
                                                <h3>{{$t('form.employee.photo')}}</h3>
                                                <input type="file"  ref="profile_image"  style="display:none" @input="showSelectedImage" accept="image/*">
                                                <img  :src="image" @click="$refs.profile_image.click()"
                                                class="img-responsive" style="cursor:pointer; max-width:200px; max-height:200px">
                                            </div>

                                            <div class="col-12">
                                                <label class="control-label" for="StatusID:">{{
                                                $t("form.student.status")
                                                }}</label>
                                                <v-select
                                                label="Name"
                                                :options="statusList"
                                                v-model="staff.Status"
                                                :reduce="status => status.id"
                                                >
                                                </v-select>
                                            </div>

                                        </div>
                                        <div class="col-md-9 col-sm-8">
                                            <div class="form-group">
                                                <label>{{$t('form.employee.title')}}</label>
                                                <v-select :options="titles" v-model="staff.Title"
                                                    :reduce="titles => titles">
                                                </v-select>
                                            </div>

                                            <div class="form-group">
                                                <label>
                                                    {{$t('form.employee.firstName')}}
                                                    <span class="text-danger">*</span>
                                                </label>
                                                <input type="text" class="form-control"
                                                    :class="{ 'is-invalid': $v.staff.FirstName.$error }"
                                                    v-model.trim="$v.staff.FirstName.$model">
                                                <div class="invalid-feedback" v-if="!$v.staff.FirstName.required">
                                                    {{$t('form.validation.required')}}</div>
                                                <div class="invalid-feedback" v-if="!$v.staff.FirstName.maxLength">
                                                    {{$t('form.validation.maxLength', {num: $v.staff.FirstName.$params.maxLength.max})}}
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label>
                                                    {{$t('form.employee.lastName')}}
                                                    <span class="text-danger">*</span>
                                                </label>
                                                <input type="text" class="form-control"
                                                    v-model.trim="$v.staff.LastName.$model"
                                                    :class="{ 'is-invalid': $v.staff.LastName.$error }">
                                                <div class="invalid-feedback" v-if="!$v.staff.LastName.required">
                                                    {{$t('form.validation.required')}}
                                                </div>
                                                <div class="invalid-feedback" v-if="!$v.staff.LastName.maxLength">
                                                    {{$t('form.validation.maxLength', {num: $v.staff.LastName.$params.maxLength.max})}}
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label>
                                                    {{$t('form.employee.birthDate')}}
                                                    <span class="text-danger">*</span>
                                                </label>
                                                <input v-model="staff.BirthDate" type="date" class="form-control"
                                                    :class="{ 'is-invalid': $v.staff.BirthDate.$error }"
                                                    v-model.trim="$v.staff.BirthDate.$model">
                                                <div class="invalid-feedback" v-if="!$v.staff.BirthDate.required">
                                                    {{$t('form.validation.required')}}
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label>
                                                    {{$t('form.employee.birthPlace')}}
                                                    <span class="req text-danger">*</span>
                                                </label>
                                                <input type="text" v-model.trim="$v.staff.BirthPlace.$model"
                                                    class="form-control"
                                                    :class="{ 'is-invalid': $v.staff.BirthPlace.$error }">
                                                <div class="invalid-feedback" v-if="!$v.staff.BirthPlace.required">
                                                    {{$t('form.validation.required')}}
                                                </div>
                                                <div class="invalid-feedback" v-if="!$v.staff.BirthPlace.maxLength">
                                                    {{$t('form.validation.maxLength', {num: $v.staff.BirthPlace.$params.maxLength.max})}}
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label>{{$t('form.employee.birthCountry')}}</label>
                                                <v-select label="printable_name" :options="countries"
                                                    v-model="staff.BirthCountry"
                                                    :reduce="countries => countries.printable_name">
                                                </v-select>
                                            </div>

                                            <div class="form-group">
                                                <label>{{$t('form.employee.department')}}</label>
                                                <v-select :options="departments" v-model="staff.Department"
                                                    :reduce="departments => departments">
                                                </v-select>
                                            </div>

                                            <div class="form-group">
                                                <label>{{$t('form.employee.position')}}</label>
                                                <v-select :options="positions" v-model="staff.Position"
                                                    :reduce="positions => positions">
                                                </v-select>
                                            </div>

                                            <div class="form-group">
                                                <label>
                                                    {{$t('form.employee.streetAddress')}}
                                                    <span class="text-danger">*</span>
                                                </label>
                                                <input type="text" v-model.trim="$v.staff.StreetAddress.$model"
                                                    class="form-control"
                                                    :class="{ 'is-invalid': $v.staff.StreetAddress.$error }">
                                                <div class="invalid-feedback" v-if="!$v.staff.StreetAddress.required">
                                                    {{$t('form.validation.required')}}
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label>
                                                    {{$t('form.employee.city')}}
                                                    <span class="text-danger">*</span>
                                                </label>
                                                <input type="text" v-model.trim="$v.staff.City.$model"
                                                    class="form-control"
                                                    :class="{ 'is-invalid': $v.staff.City.$error }">
                                                <div class="invalid-feedback" v-if="!$v.staff.City.required">
                                                    {{$t('form.validation.required')}}</div>
                                                <div class="invalid-feedback" v-if="!$v.staff.City.maxLength">
                                                    {{$t('form.validation.maxLength', {num: $v.staff.City.$params.maxLength.max})}}
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label>
                                                    {{$t('form.employee.zip')}}
                                                    <span class="text-danger">*</span>
                                                </label>
                                                <input type="text" v-model.trim="$v.staff.Zip.$model"
                                                    class="form-control" :class="{ 'is-invalid': $v.staff.Zip.$error }">
                                                <div class="invalid-feedback" v-if="!$v.staff.Zip.required">
                                                    {{$t('form.validation.required')}}</div>
                                                <div class="invalid-feedback" v-if="!$v.staff.Zip.maxLength">
                                                    {{$t('form.validation.maxLength', {num: $v.staff.Zip.$params.maxLength.max})}}
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label>{{$t('form.employee.country')}}<span
                                                        class="text-danger">*</span></label>
                                                <v-select label="printable_name" :options="countries"
                                                    v-model.trim="$v.staff.Country.$model"
                                                    :reduce="countries => countries.printable_name">
                                                </v-select>
                                                <div class="invalid-feedback custom-validate" v-if="invalidCountry">
                                                    {{$t('form.validation.required')}}
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label>
                                                    {{$t('form.employee.phone')}}
                                                    <span class="text-danger">*</span>
                                                </label>
                                                <input type="text" v-model.trim="$v.staff.Phone.$model"
                                                    class="form-control"
                                                    :class="{ 'is-invalid': $v.staff.Phone.$error }">
                                                <div class="invalid-feedback" v-if="!$v.staff.Phone.required">
                                                    {{$t('form.validation.required')}}</div>
                                                <div class="invalid-feedback" v-if="!$v.staff.Phone.maxLength">
                                                    {{$t('form.validation.maxLength', {num: $v.staff.Phone.$params.maxLength.max})}}
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label>
                                                    {{$t('form.employee.mobile')}}
                                                    <span class="text-danger">*</span>
                                                </label>
                                                <input type="text" v-model.trim="$v.staff.Mobile.$model"
                                                    class="form-control"
                                                    :class="{ 'is-invalid': $v.staff.Mobile.$error }">
                                                <div class="invalid-feedback" v-if="!$v.staff.Mobile.required">
                                                    {{$t('form.validation.required')}}</div>
                                                <div class="invalid-feedback" v-if="!$v.staff.Mobile.maxLength">
                                                    {{$t('form.validation.maxLength', {num: $v.staff.Mobile.$params.maxLength.max})}}
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label>
                                                    {{$t('form.employee.email')}}
                                                    <span class="text-danger">*</span>
                                                </label>
                                                <input type="email" v-model.trim="$v.staff.Email.$model"
                                                    class="form-control"
                                                    :class="{ 'is-invalid': $v.staff.Email.$error }">
                                                <div class="invalid-feedback" v-if="!$v.staff.Email.required">
                                                    {{$t('form.validation.required')}}</div>
                                                <div class="invalid-feedback" v-if="!$v.staff.Email.email">
                                                    {{$t('form.validation.validEmail')}}
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label>{{$t('form.employee.email2')}}</label>
                                                <input v-model="staff.Email2" type="text" class="form-control">
                                            </div>

                                            <div class="form-group">
                                                <label>{{$t('form.employee.email3')}}</label>
                                                <input v-model="staff.Email3" type="text" class="form-control">
                                            </div>

                                            <div class="form-group">
                                                <label>{{$t('form.employee.webAddress')}}</label>
                                                <input v-model="staff.WebAddress" class="form-control">
                                            </div>

                                            <div class="form-group">
                                                <label>{{$t('form.employee.vacationBalance')}}</label>
                                                <input type="text" class="form-control"
                                                    v-model.trim="$v.staff.VacationBalancePerYear.$model"
                                                    :class="{ 'is-invalid': $v.staff.VacationBalancePerYear.$error }">
                                                <div class="invalid-feedback"
                                                    v-if="!$v.staff.VacationBalancePerYear.integer">
                                                    {{$t('form.validation.integerAllowed')}}
                                                </div>
                                            </div>

                                            
                                            <div class="form-group">
                                                <label>{{$t('form.employee.workload')}}</label>
                                                <input type="text" class="form-control"
                                                    v-model.trim="$v.staff.Workload.$model"
                                                    :class="{ 'is-invalid': $v.staff.Workload.$error }">
                                                <div class="invalid-feedback"
                                                    v-if="!$v.staff.Workload.integer">
                                                    {{$t('form.validation.integerAllowed')}}
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </b-tab>

                                <b-tab :title="$t('form.employee.tabContracts')">
                                    <div class="row">
                                        <div class="col-md-8">
                                            <div class="table-responsive p-0">
                                                <table class="table table-bordered">
                                                    <tr>
                                                        <th>{{$t('form.employee.file')}}</th>
                                                        <th>{{$t('form.student.UploadTimestamp')}}</th>
                                                        <th>{{$t('form.employee.fileName')}}</th>
                                                        <th>{{$t('form.employee.fileDescription')}}</th>
                                                        <th class="text-right">{{$t('form.employee.action')}}</th>
                                                    </tr>
                                                    <tbody>
                                                        <tr v-for="(file , index) in contracts" v-bind:key="index">
                                                            <td>
                                                                <i class="fa fa-file" aria-hidden="true"></i>
                                                            </td>
                                                            <td class="text-center">
                                                                {{file.UploadTimestamp}}
                                                            </td>
                                                            <td>{{file.Name}}

                                                                | <a href="#" @click.prevent="downloadContract(file)" class="ml-2"> {{$t('button.view')}}</a>

                                                            </td>
                                                            <td>
                                                                <input type="text" class="form-control"
                                                                    v-model="contracts[index].Description">
                                                            </td>
                                                            <td class="text-right">
                                                                <span style="color:red;cursor:pointer"
                                                                    @click="removeContract(index,file)">
                                                                    <i class="fa fa-times"></i>
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>

                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label class="control-label"
                                                    for="StatusID:">{{$t('form.employee.fileAttach')}}</label>

                                                <vue-dropzone ref="myVueDropzone" id="dropzone2"
                                                    :options="contractDropzone" @vdropzone-success="contractUploaded"
                                                    @vdropzone-error="uploadFileError" @vdropzone-processing="isLoading=true">
                                                </vue-dropzone>
                                            </div>
                                        </div>
                                    </div>
                                </b-tab>

                                <b-tab :title="$t('form.student.tabAttachment')">
                                    <div class="row">
                                        <div class="col-md-8">
                                            <!-- <br> -->
                                            <div class="table-responsive p-0">
                                                <table class="table table-bordered">
                                                    <tr>
                                                        <th>{{$t('form.student.file')}}</th>
                                                        <th>{{$t('form.student.UploadTimestamp')}}</th>
                                                        <th>{{$t('form.student.fileName')}}</th>
                                                        <th>{{$t('form.student.fileDescription')}}</th>
                                                    </tr>
                                                    <tbody>
                                                        <tr v-for="(file , index) in attachments" :key="index">
                                                            <td class="text-center">
                                                                <i class="fa fa-file" aria-hidden="true"></i>
                                                            </td>
                                                            <td class="text-center">
                                                                {{file.UploadTimestamp}}
                                                            </td>
                                                            <td>{{file.Name}}
                                                                 | <a href="#" @click.prevent="downloadAttachment(file)" class="ml-2"> {{$t('button.view')}}</a>

                                                            </td>
                                                            <td>
                                                                <input type="text" class="form-control"
                                                                    v-model="attachments[index].Description">
                                                            </td>
                                                            <td>
                                                                <span style="color:red;cursor:pointer"
                                                                    @click="removeAttachment(index,file)">
                                                                    <i class="fa fa-times"></i>
                                                                </span>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>

                                        <div class="col-md-4">
                                            <div class="form-group">
                                                <label class="control-label"
                                                    for="StatusID:">{{$t('form.student.fileAttach')}}</label>

                                                <vue-dropzone ref="myVueDropzone" id="dropzone"
                                                    :options="attachmentDropzone"
                                                    @vdropzone-success="attachmentUploaded"
                                                    @vdropzone-error="uploadFileError"
                                                    @vdropzone-processing="isLoading=true">
                                                </vue-dropzone>
                                            </div>
                                        </div>
                                    </div>
                                </b-tab>
                            </b-tabs>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import vue2Dropzone from "vue2-dropzone";

    import {
        required,
        minLength,
        maxLength,
        email,
        integer
    } from "vuelidate/lib/validators";

    export default {
        props: ["permissions"],

        components: {
            vueDropzone: vue2Dropzone,
        },

        data() {
            return {
                alert: false,
                alertClass: '',
                alertMessage: '',

                isLoading: false,
                fullPage: true,

                invalidCountry: false,
                image: '/images/default.jpg',

                avatarDropzoneOptions: {
                    url: "/api/staff/profile-image",
                    headers: {
                        "X-CSRF-TOKEN": document.head.querySelector("[name=csrf-token]")
                            .content,
                        Authorization: "Bearer " + localStorage.getItem("token")
                    },
                    thumbnailWidth: 150,
                    thumbnailHeight: 150,
                    addRemoveLinks: true,
                    maxFiles: 1
                },

                contractDropzone: {
                    url: "/api/staff/contracts/add",
                    headers: {
                        "X-CSRF-TOKEN": document.head.querySelector("[name=csrf-token]")
                            .content,
                        Authorization: "Bearer " + localStorage.getItem("token")
                    },
                    thumbnailWidth: 150, // px
                    thumbnailHeight: 150
                },

                attachmentDropzone: {
                    url: "/api/staff/attachments/add",
                    headers: {
                        "X-CSRF-TOKEN": document.head.querySelector("[name=csrf-token]")
                            .content,
                        Authorization: "Bearer " + localStorage.getItem("token")
                    },
                    thumbnailWidth: 150, // px
                    thumbnailHeight: 150
                },

                staff: {
                    FirstName: null,
                    LastName: null,
                    Title: null,
                    BirthDate: null,
                    BirthPlace: null,
                    BirthCountry: null,
                    StreetAddress: null,
                    City: null,
                    Zip: null,
                    Country: null,
                    Phone: null,
                    Mobile: null,
                    Fax: null,
                    Email: null,
                    Email2: null,
                    Email3: null,
                    WebAddress: null,
                    Photo: null,
                    Department: null,
                    Position: null,
                    VacationBalancePerYear: 0,
                    Workload:0,
                    Status:null,
                },

                status: {
                    id: "",
                    Name: "",
                },

                titles: [],
                statusList: [],
                departments: [],
                positions: [],
                countries: [],
                contracts: [],
                attachments: [],
            }
        },

        validations: {
            staff: {
                FirstName: {
                    required,
                    maxLength: maxLength(100)
                },
                LastName: {
                    required,
                    maxLength: maxLength(100)
                },
                BirthPlace: {
                    required,
                    maxLength: maxLength(100)
                },
                BirthDate: {
                    required
                },
                StreetAddress: {
                    required
                },
                City: {
                    required,
                    maxLength: maxLength(100)
                },
                Country: {
                    required
                },
                Zip: {
                    required,
                    maxLength: maxLength(50)
                },
                Phone: {
                    required,
                    maxLength: maxLength(100)
                },
                Mobile: {
                    required,
                    maxLength: maxLength(100)
                },
                Email: {
                    required,
                    email
                },
                VacationBalancePerYear: {
                    integer
                },
                Workload: {
                    integer
                }
            }
        },

        mounted() {
            if (!this.permissions.createEmployeeStaff) {
                this.$router.push("/");
                return;
            }

            this.getInitialData();
        },

        methods: {
            async createToken(type = null) {
                let response = await axios.post('/api/api-tokens', {
                    type: `staff-${type}`,
                    staff: this.staff.ID
                });

                let token = '';

                if (response.status == 200) {
                    token = response.data.extra[0].token
                }

                return token;
            },


            async downloadAttachment(file , isDownload = false) {

                let token = await this.createToken('attachment');
                if (token == '') return;
                window.open(`/staff/attachments/${file.ID}?file=${file.File}&download=${isDownload}&token=${token}`, '_blank');

           },

            async downloadContract(file , isDownload = false) {
                let token = await this.createToken('contract');
                if (token == '') return;
                window.open(`/staff/contracts/${file.ID}?file=${file.File}&download=${isDownload}&token=${token}`, '_blank');
            },

            getInitialData() {
                this.isLoading = true;

                axios
                    .get("/api/staff/initial-data")
                    .then(response => {
                        this.isLoading = false;

                        this.departments = response.data.departments;
                        this.positions = response.data.positions;
                        this.countries = response.data.countries;
                        this.titles = response.data.titles;
                        this.statusList = response.data.status;

                        // Set staff.Status to the ID of the "Active" status
                        const activeStatus = this.statusList.find(status => status.name === 'Active');
                        if (activeStatus) {
                            this.staff.Status = activeStatus.id;
                        } else {
                            // Set a fallback status ID if "Active" status is not found
                            this.staff.Status = this.statusList.length > 0 ? this.statusList[0].id : null;
                        }
                    })
                    .catch(error => {
                        console.log('error');
                        this.isLoading = false;
                    });
            },

              // show selecete image
            showSelectedImage(){

                 let input = this.$refs.profile_image
                let file = input.files
                if (file && file[0]) {
                let reader = new FileReader
                reader.onload = e => {
                    this.image = e.target.result
                }
                reader.readAsDataURL(file[0])
                this.$emit('input', file[0])
                }

                let fd = new FormData();
                fd.append('file',file[0]);
                this.isLoading = true;
                axios.post('/api/staff/profile-image',fd).then(resp=>{
                    this.staff.Photo = resp.data.filename;
                    this.isLoading = false;
                }).catch(error=>{
                    this.isLoading = false;
                    console.log('file not found');
                });
            },

            contractUploaded(file, response) {
                this.isLoading = false;

                this.contracts.push({
                    Name: response.filename,
                    File: `${response.id}/${response.filename}`,
                    Description: '',
                    AttachmentDate: moment().format('YYYY-MM-DD'),
                    UploadTimestamp: calculateTimeAsPerTimeZone('+2')
                });
            },

            removeContract(index, attach) {
                let vm = this;

                if (confirm(this.$t('form.validation.delete'))) {
                    axios
                        .post("/api/staff/contracts/remove", attach)
                        .then(response => {
                            this.showAlert(response.data.message)
                            vm.contracts.splice(index, 1);
                        })
                        .catch(error => {
                            console.log(error);
                        });
                }
            },

            /**
             * Upload file error on dropzone
             */
            uploadFileError(file, message) {
                this.showAlert(message.errors, 'danger');
                this.isLoading = false;
            },

            /**
             * Add attachment to student attachment list
             */
            attachmentUploaded(file, response) {
                this.isLoading = false;

                this.attachments.push({
                    Name: response.filename,
                    File: `${response.id}/${response.filename}`,
                    Description: '',
                    AttachmentDate: moment().format('YYYY-MM-DD'),
                    UploadTimestamp: calculateTimeAsPerTimeZone('+2')
                });
            },

            /**
             * Remove attachmemnt from student attachment list
             */
            removeAttachment(index, attach) {
                let vm = this;

                if (confirm(this.$t('form.validation.delete'))) {
                    axios
                        .post("/api/staff/attachments/remove", attach)
                        .then(response => {

                            if (response.data.error) {
                                this.showAlert(response.data.message, 'warning');
                            } else if (response.data.success) {
                                vm.attachments.splice(index, 1);
                                this.showAlert(response.data.message);
                            }

                        })
                        .catch(error => {
                            console.log('error');
                        });
                }
            },

            saveStaff() {
                this.$v.$touch();

                this.invalidCountry = this.staff.Country == null ? true : false;

                if (this.$v.$invalid) {
                 
                
                    let errorMsg = '';

                    if(this.$v.staff.FirstName.$error){
                            errorMsg = this.$t('form.employee.firstName');
                      }

                     if(this.$v.staff.LastName.$error){
                            errorMsg =  errorMsg ? errorMsg+', '+this.$t('form.employee.lastName'): this.$t('form.employee.lastName');
                      }

                    if(this.$v.staff.Email.$error){
                             errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.email'): this.$t('form.employee.email');
                      }

                    if(this.$v.staff.BirthPlace.$error){
                            errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.birthPlace'): this.$t('form.employee.birthPlace');
                      }

                    if(this.$v.staff.BirthDate.$error){
                           errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.birthDate'): this.$t('form.employee.birthDate');
                      }

                    if(this.$v.staff.StreetAddress.$error){
                             errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.streetAddress'): this.$t('form.employee.streetAddress');
                      }

                        
                        if(this.$v.staff.City.$error){
                             errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.city'): this.$t('form.employee.city');
                      }

                        if(this.$v.staff.Country.$error){
                             errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.country'): this.$t('form.employee.country');
                      }

                       if(this.$v.staff.Zip.$error){
                             errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.zip'): this.$t('form.employee.zip');
                      }

                    if(this.$v.staff.Mobile.$error){
                             errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.mobile'): this.$t('form.employee.mobile');
                      }

                    if(this.$v.staff.Phone.$error){
                             errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.phone'): this.$t('form.employee.phone');
                      }

                     if(this.$v.staff.VacationBalancePerYear.$error){

                             errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.vacationBalance'): this.$t('form.employee.vacationBalance');
                      
                      }

                      if(this.$v.staff.Workload.$error){

                        errorMsg = errorMsg ? errorMsg+', '+ this.$t('form.employee.workload'): this.$t('form.employee.workload');

                        }
                 


                    this.showAlert(this.$t('form.validation.mandatoryFieldsError', {errors:errorMsg}), 'danger');
                    return; 
                }

                

                if (this.staff.VacationBalancePerYear == '')
                    this.staff.VacationBalancePerYear = 0;      
                if (this.staff.Workload == '')
                    this.staff.Workload = 0;

                this.isLoading = true;

                let formData = new FormData();

                if (this.status.id) {
                    this.staff.Status = this.status.id;

                    formData.append(
                        "status[]",
                        JSON.stringify({
                            id: this.status.id,
                        })
                    );
                }

                formData.append('staff', JSON.stringify(this.staff));

                this.contracts.forEach(contract => {

                    contract.UploadTimestamp = contract.UploadTimestamp ? contract.UploadTimestamp : null
                    formData.append("contracts[]", JSON.stringify(contract));
                    
                });

                this.attachments.forEach(attach => 
                {
                    attach.UploadTimestamp = attach.UploadTimestamp ? attach.UploadTimestamp : null
                    formData.append("attachments[]", JSON.stringify(attach));
                
                });

                axios
                    .post("/api/staff", formData)
                    .then(response => {
                        this.isLoading = false;

                        if (response.data.success) {
                            this.showAlert(response.data.message);

                            setTimeout(() => {
                                this.$router.push({
                                    name: 'StaffIndex'
                                });
                            }, 2000);
                        }
                    })
                    .catch(error => {
                        this.isLoading = false;
                        console.log('error');
                    });
            },

            showAlert(msg, cls = 'success') {
                this.alertMessage = msg;
                this.alertClass = cls;
                this.alert = true;
            }
        }
    };

</script>

<style scoped>
    .custom-validate {
        display: block !important;
    }

</style>
